import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { get } from '../../services/apiController';

const Vendor = ({ name, vendorId, handleVendorChange, isDisabled = false }) => {
  const [vendorsList, setVendorsList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  function getVendors() {
    try {
      get(`/vendor-masters`).then((response) => {
        setVendorsList(response.data.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err.message);
    }
  }

  useEffect(() => {
    getVendors();
  }, []);

  useEffect(() => {
    if (vendorId) {
      const vendor = vendorsList.find((item) => item.id === +vendorId);
      setSelectedVendor({ value: vendor?.id, label: vendor?.name }); // Correct the way of updating state
    }
  }, [vendorId, vendorsList]);

  const vendorOptions = vendorsList.map((item) => ({
    value: item?.id,
    label: item?.name,
  }));

  return (
    <Select
      name={name}
      placeholder="Select vendor"
      isDisabled={isDisabled}
      value={selectedVendor}
      isClearable
      isSearchable
      options={vendorOptions}
      onChange={(selectedVendor) => {
        setSelectedVendor({ value: selectedVendor?.value, label: selectedVendor?.label });
        handleVendorChange(selectedVendor?.value ?? '');
      }}
      styles={{
        control: (provided, state) => ({
          ...provided,
          minHeight: '55px',
        }),
      }}
    />
  );
};

export default React.memo(Vendor);
